// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"164":"4cf4aa32","245":"37230fae","366":"d6617d20"}[chunkId] + ".js";
};